function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import Svg, { Defs, G, Rect, Path, Circle } from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: filter */

var _ref = /*#__PURE__*/React.createElement(Defs, null);

var _ref2 = /*#__PURE__*/React.createElement(G, {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement(Rect, {
  width: 42,
  height: 42,
  rx: 13.44,
  fill: "#5B41F0"
}), /*#__PURE__*/React.createElement(G, {
  filter: "url(#icon-help_svg__a)"
}, /*#__PURE__*/React.createElement(G, {
  transform: "translate(12.6 10.08)"
}, /*#__PURE__*/React.createElement(Path, {
  d: "M8.141 3.672a5.738 5.738 0 00-5.728 5.88c.04 2.08.93 3.262 1.79 4.406.815 1.083 1.584 2.105 1.584 3.858 0 0 0 0 0 0v.25h4.71v-.25c0-1.753.77-2.775 1.583-3.858.86-1.144 1.75-2.326 1.79-4.406v-.004l.001-.068.001-.076a5.738 5.738 0 00-5.73-5.732zM5.788 19.313h4.708M6.344 20.56H9.94M6.9 21.806h2.484",
  stroke: "#9C99B1",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 0.84
}), /*#__PURE__*/React.createElement(Circle, {
  cx: 8.19,
  cy: 0.63,
  r: 1,
  fill: "#9C99B1"
}), /*#__PURE__*/React.createElement(Circle, {
  cx: 3.99,
  cy: 1.47,
  r: 1,
  fill: "#9C99B1"
}), /*#__PURE__*/React.createElement(Circle, {
  cx: 0.63,
  cy: 4.83,
  r: 1,
  fill: "#9C99B1"
}), /*#__PURE__*/React.createElement(Circle, {
  cx: 12.39,
  cy: 1.47,
  r: 1,
  fill: "#9C99B1"
}), /*#__PURE__*/React.createElement(Circle, {
  cx: 15.75,
  cy: 4.83,
  r: 1,
  fill: "#9C99B1"
}))));

function SvgIconHelp(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 42,
    height: 42
  }, props), _ref, _ref2);
}

export default SvgIconHelp;